/** @format */

import React from "react";

export const SlideToggleSwitch = ({ toggleState, setToggleState, checkBoxId, fromBtn, setFromBtn }) => {
    const handleSwitchToggled = (e) => {
        const targetNodeName = e.target.nodeName;
        // console.log("button: ",targetNodeName);
        const validNodes = ["label", "input", "i"];
        // check it's coming from toggle switch
        if (validNodes.includes(targetNodeName.toLowerCase())) {
            setToggleState(!toggleState);
        }
    };
    return (
        <>
            <input
                type="checkbox"
                className="toggle"
                onChange={handleSwitchToggled}
                checked={toggleState}
                id={checkBoxId}
            />
            <label htmlFor={checkBoxId}>
                <i className={`${toggleState ? "fa-solid" : "fa-regular"} fa-envelope fa-sm`} />
            </label>
        </>
    );
};
